module.exports = __webpack_public_path__ + "img/logo.055555b6.webp";